/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Insurer_UserInputs */

const es_co2_error_email_insurer_user = /** @type {(inputs: Error_Email_Insurer_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este correo pertenece a un usuario de aseguradora y no puede unirse a una empresa constructora.`)
};

/**

* @param {Error_Email_Insurer_UserInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_email_insurer_user = /** @type {((inputs?: Error_Email_Insurer_UserInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Insurer_UserInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_email_insurer_user(inputs)
});